import { useEffect, useRef } from 'react';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { snackbar } from '@occc-app/design-system';

import { DOWNLOAD_ERRORS } from './file-download.constants';
import { useS3Loader } from './use-s3-download.hook';
import { FileDownloadPage } from './file-download.page';

type FileDownloadControllerProps = {
  pageTitle: string;
  title: string;
  subtitle: string;
  filename?: string;
  loader: {
    type: 's3';
    s3Url: string;
  };
};

export const FileDownloadController = ({
  pageTitle,
  title,
  subtitle,
  filename = 'file',
  loader,
}: FileDownloadControllerProps) => {
  const isDownloadStarted = useRef(false);

  const { download, loading } = useS3Loader({
    filename,
    onError: () => snackbar.error(DOWNLOAD_ERRORS.generic),
  });

  useEffect(() => {
    if (!isDownloadStarted.current) {
      isDownloadStarted.current = true;
      download(loader.s3Url);
    }
  }, [download, loader.s3Url]);

  const handleDownload = () => {
    download(loader.s3Url);
  };

  return (
    <FileDownloadPage
      pageTitle={pageTitle}
      title={title}
      subtitle={subtitle}
      onDownload={handleDownload}
      loading={loading}
    />
  );
};
